import util from '@/api/util'

export const MY_CONSTANTS = {
    $apiurl: util.apiUrl(),
    $imgurl: util.apiUrl(),
    $cloudurl: util.cloudurl(),
    $hfurl: util.hfurl(),
    $zturl: util.zturl(),
    $url: util.apiUrl(),
    $imgfile: util.imgkey(),
    $host: window.location.origin,
}

export const typeObj = {
  1: {
    label: '教育局',
    background: '#EDF6FF',
    color: '#4e86ff',
    type: 1
  },
  2: {
    label: '校管辖单位',
    background: '#E8EDFB',
    color: '#4E84FF',
    type: 2
  },
  3: {
    label: '机构',
    background: '#E9E8FF',
    color: '#7770E4',
    type: 3
  },
  4: {
    label: '学校',
    background: '#EBFFEA',
    color: '#52BE41',
    type: 4
  },
  5: {
    label: '校区',
    background: '#FFF9E8',
    color: '#F58623',
    type: 5
  },
  6: {
    label: '学段',
    background: '#FFEEED',
    color: '#E47470',
    type: 6
  },
  7: {
    label: '年段',
    background: '#F6E8FF',
    color: '#D170E4',
    type: 7
  },
  8: {
    label: '班级',
    background: '#E8FFFB',
    color: '#26BFD1',
    type: 8
  },
  9: {
    label: '行政部门',
    background: '#FFE9E8',
    color: '#E47470',
    type: 9
  },
  '': {
    label: '无类型',
    background: '#E7E7E7',
    color: '#333333',
    type: ''
  }
}

export const statusType = {
  0: {
    text: '处理中',
    class: 'processing'
  },
  1: {
    text: '已完成',
    class: 'passed'
  },
  2: {
    text: '已退回',
    class: 'refuse'
  },
  3: {
    text: '撤回',
    class: 'cancle'
  }
}

